import { ARTICLE_MASTER_FORM_RESET, CREATE_ARTICLE_MASTER_FAILURE, CREATE_ARTICLE_MASTER_FORM, CREATE_ARTICLE_MASTER_REQUEST, CREATE_ARTICLE_MASTER_SUCCESS, DELETE_ARTICLE_MASTER_FAILURE, DELETE_ARTICLE_MASTER_REQUEST, DELETE_ARTICLE_MASTER_SUCCESS, FETCH_ARTICLE_MASTER_BY_ARTICLE_NUMBER_DATA_FAILURE, FETCH_ARTICLE_MASTER_BY_ARTICLE_NUMBER_DATA_REQUEST, FETCH_ARTICLE_MASTER_BY_ARTICLE_NUMBER_DATA_SUCCESS, FETCH_ARTICLE_MASTER_CONSUMED_DATA_FAILURE, FETCH_ARTICLE_MASTER_CONSUMED_DATA_REQUEST, FETCH_ARTICLE_MASTER_CONSUMED_DATA_SUCCESS, FETCH_ARTICLE_MASTER_DATA_FAILURE, FETCH_ARTICLE_MASTER_DATA_REQUEST, FETCH_ARTICLE_MASTER_DATA_SUCCESS, FETCH_SINGLE_ARTICLE_MASTER_FAILURE, FETCH_SINGLE_ARTICLE_MASTER_REQUEST, FETCH_SINGLE_ARTICLE_MASTER_SUCCESS, SET_NON_RATIO_SIZE_DATA, SET_RATIO_NAME_ARTICLE_MASTER, UPDATE_ARTICLE_MASTER_FAILURE, UPDATE_ARTICLE_MASTER_REQUEST, UPDATE_ARTICLE_MASTER_SUCCESS } from "./articleMaster.actionsType";

export const ARTICLE_MASTER = 'articleMasterReducer';

let initialState = {
    loading: false,
    articleMasterData: [],
    errorMessage: '',
    articlemasterform: {
        fldArticleNumber: '',
        fldEANNumber: '',
        fldIsRatioPacking: false,
        //fldIsMultiSize: false,
        fldSize: '',
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        fldCBLength: 0,
        fldCBWidth: 0,
        fldCBHeight: 0,
        fldPerBoxCBM: 0,
        fldFKHSNCode: 0
    },
    articleMasterupdatedData: [],
    ratioTab: 'RATIO',
    articleMasterArr: []
};

export let articleMasterReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case CREATE_ARTICLE_MASTER_REQUEST:
        case UPDATE_ARTICLE_MASTER_REQUEST:
        case DELETE_ARTICLE_MASTER_REQUEST:
        case FETCH_SINGLE_ARTICLE_MASTER_REQUEST:
        case FETCH_ARTICLE_MASTER_DATA_REQUEST:
        case FETCH_ARTICLE_MASTER_BY_ARTICLE_NUMBER_DATA_REQUEST:

            return {
                ...state,
                loading: true
            };
        case CREATE_ARTICLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                detailsId: updatePayload
            };
        case CREATE_ARTICLE_MASTER_FORM:
            return {
                ...state,
                loading: false,
                articlemasterform: {
                    ...state.articlemasterform,
                    [payload.key]: payload.value,

                }
            };
        case UPDATE_ARTICLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                articlemasterform: {}
            };
        case DELETE_ARTICLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                articlemasterform: {}
            };
        case FETCH_SINGLE_ARTICLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                articlemasterform: {
                    ...updatePayload, fldIsMultiSizeUpdated: false,
                    startDate: state.articlemasterform.startDate,
                    endDate: state.articlemasterform.endDate,
                }
            };
        case FETCH_ARTICLE_MASTER_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                articleMasterData: updatePayload
            };
        case FETCH_ARTICLE_MASTER_BY_ARTICLE_NUMBER_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                articleMasterupdatedData: updatePayload
            };
        case SET_RATIO_NAME_ARTICLE_MASTER:
            return {
                ...state,
                ratioTab: payload
            };
        case CREATE_ARTICLE_MASTER_FAILURE:
        case UPDATE_ARTICLE_MASTER_FAILURE:
        case DELETE_ARTICLE_MASTER_FAILURE:
        case FETCH_SINGLE_ARTICLE_MASTER_FAILURE:
        case FETCH_ARTICLE_MASTER_DATA_FAILURE:
        case FETCH_ARTICLE_MASTER_BY_ARTICLE_NUMBER_DATA_FAILURE:

            return {
                ...state,
                loading: false
            };
        case ARTICLE_MASTER_FORM_RESET:
            return {
                ...state,
                articlemasterform: {
                    fldArticleNumber: '',
                    fldEANNumber: '',
                    fldIsRatioPacking: false,
                    //fldIsMultiSize: false,
                    fldSize: '',
                    startDate: state.articlemasterform.startDate,
                    endDate: state.articlemasterform.endDate,
                    fldFKHSNCode: 0,
                },
                articleMasterArr: [],
            };
        case SET_NON_RATIO_SIZE_DATA:
            return {
                ...state,
                loading: false,
                articleMasterArr: payload
            };
        default:
            return state;
    }
};